import { render } from "./AssetTypePage.vue?vue&type=template&id=25df3087"
import script from "./AssetTypePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetTypePage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Playbooks/Admin/AssetTypePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25df3087"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25df3087', __exports__)) {
    api.reload('25df3087', __exports__)
  }
  
  module.hot.accept("./AssetTypePage.vue?vue&type=template&id=25df3087", () => {
    api.rerender('25df3087', render)
  })

}


export default __exports__